import React, { useEffect, useRef } from 'react';
import { Card, Space } from 'antd';
import './TextContent.less';
import { useSize } from 'ahooks';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import useDataSource from 'hooks/useDataSource';
import { useHistory } from 'react-router-dom';

const TextContent = ({ content, onSizeChange }) => {
  const cardRef = useRef();
  const size = useSize(cardRef);
  const { dataSourceId } = useDataSource();
  const history = useHistory();

  useEffect(() => {
    onSizeChange?.(content.id, size);
  }, [size, content.id, onSizeChange]);

  // Intercept internal links in rich text
  useEffect(() => {
    cardRef.current.querySelectorAll('a').forEach((link) => {
      const linkUrl = new URL(link.href);
      if (linkUrl.origin === document.location.origin) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          history.push(linkUrl.pathname.replace(process.env.MANAGER_BASE_PATH, ''));
        });
      }
    });
  }, []);

  return (
    <Card
      className="dashboard__content"
      title={(
        <Space>
          {content.title}
        </Space>
      )}
      extra={(
        <CopyToClipboardButton textToCopy={JSON.stringify({ title: content.title, richText: content.richText, type: content.type })} />
      )}
      ref={cardRef}
    >
      <div
        className="dashboard-text-content"
        dangerouslySetInnerHTML={{
          __html: content.richText?.replaceAll(/\{legacyAnalytics(\/.*)?\}/g, `${process.env.MANAGER_BASE_PATH}/data-sources/${dataSourceId}/analytics$1`) || '<p>No content yet. Click Edit to add text.</p>',
        }}
      />
    </Card>
  );
};

export default TextContent;
